var map = {
	"./br/PT/S1/bg67c.png": 29395,
	"./br/PT/bg67c.png": 96226,
	"./in/EN/S1/bg67c.png": 63953,
	"./ph/EN/S1/bg67c.png": 15298,
	"./ph/EN/bg67c.png": 55669,
	"./vn/VI/S1/bg67c.png": 66229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55485;